import angular from 'angular';
import '../common_utils/common_app.es6';

import 'ui-select'
import 'angular-ui-bootstrap'
import 'angular-bootstrap-colorpicker'
import '../common_utils/directives/wysiwyg.es6'
import 'angular-ui-notification'
import 'angularjs-slider'

// import ngRailsCsrf from '../common_utils/ng-rails-csrf.es6';
import 'angular-ui-sortable';
import '../common_utils/ng-tags-input';
import '../common_utils/angular-chosen';

var ExpressApp = angular.module("express", [
  'common_app',
  'colorpicker.module',
  'ui.bootstrap',
  'wysiwyg.module',
  'ui-notification',
  'ui.sortable',
  'ui.select',
  'ngTagsInput',
  'localytics.directives',
  'rzModule'
]);

ExpressApp.config(['NotificationProvider', (NotificationProvider) => {
  NotificationProvider.setOptions({
    delay: 100000,
    closeOnClick: true
  });
}]);

export default ExpressApp;